import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import VerifyAddress from "./VerifyAddress";
import SelectRecord from "./SelectRecord";
import DgWarningDialog from "../Layouts/Datagrid/WarningDialog";

function FormDialogs({ handleFormSave, handleDialogAction, tabIndexRef }) {
  const {
    formDialog: { fieldProps, type },
  } = useSelector((state) => state.formDialog);

  if (fieldProps && fieldProps.custom === "verifyAddress")
    return <VerifyAddress handleFormSave={handleFormSave} />;

  if (fieldProps && fieldProps.custom === "selectRecord")
    return <SelectRecord handleFormSave={handleFormSave} />;

  if (type === "dgWarning")
    return (
      <DgWarningDialog
        handleDialogAction={handleDialogAction}
        tabIndexRef={tabIndexRef}
      />
    );

  return "";
}
FormDialogs.propTypes = {
  handleFormSave: PropTypes.func,
  handleDialogAction: PropTypes.func,
  tabIndexRef: PropTypes.shape({}),
};
FormDialogs.defaultProps = {
  handleFormSave: undefined,
  handleDialogAction: undefined,
  tabIndexRef: undefined,
};
export default FormDialogs;
